import { NgModule } from '@angular/core';

import { ConfidenceLabelPipe } from './confidence-label.pipe';

@NgModule({
  declarations: [ConfidenceLabelPipe],
  exports: [ConfidenceLabelPipe],
})
export class ConfidenceLabelPipeModule {}
